import { PERMISSION, PERMISSION_ROLE, PERMISSION_TYPE } from "lib/constants";

export const PERMISSION_OPTIONS = [
    { text: "Admin", value: PERMISSION_ROLE.ADMIN },
    { text: "Editor", value: PERMISSION_ROLE.EDITOR },
    { text: "View-only", value: PERMISSION_ROLE.VIEWER },
    { text: "No access", value: PERMISSION_ROLE.NONE },
];

const permissionTypeToRole = new Map([
    [PERMISSION_TYPE.ADMIN, [PERMISSION_ROLE.ADMIN]],
    [PERMISSION_TYPE.EDIT, [PERMISSION_ROLE.ADMIN, PERMISSION_ROLE.EDITOR]],
    [PERMISSION_TYPE.VIEW, [PERMISSION_ROLE.ADMIN, PERMISSION_ROLE.EDITOR, PERMISSION_ROLE.VIEWER]],
    [PERMISSION_TYPE.NONE, [PERMISSION_ROLE.ADMIN]],
]);

export const validRolesForPermissionType = (permissionType) =>
    permissionTypeToRole.get(permissionType) || permissionTypeToRole.get(PERMISSION_TYPE.NONE);

/**
 * This will tell you which managers (from the Team API) have the
 * given access for the given permission.
 */
export function getManagersForPosition(position, managers, permission, permissionType) {
    let allAccess = "hire_all_access";
    let access = "hire_access";
    let permissionRole = "hire_permission_role";

    if (permission === PERMISSION.RETAIN) {
        allAccess = "retain_all_access";
        access = "retain_access";
        permissionRole = "retain_permission_role";
    }

    const validRoles = validRolesForPermissionType(permissionType);

    return managers.filter(
        (m) =>
            validRoles.includes(m[permissionRole]) &&
            (m[allAccess] ||
                m.position_managers.find((pm) => pm.position_id === position.id && pm[access]) ||
                m.facility_managers.find(
                    (fm) => fm.facility_id === position.facility_id && fm[access],
                )),
    );
}
